module.exports = __webpack_public_path__ + "static/media/20210212_194833_672_IMG_2061.2bbb49f1.jpg";